import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";
import Mainroutes from './Pages/Mainroutes';
import { ToastContainer } from 'react-toastify';
import "antd/dist/reset.css";

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        {/* <Route path='/*' element={
          <div className="mobile-container">
            <p>Hello World </p>

          </div>}
        /> */}
        

        <Route path='/*' element={<Mainroutes />} />
        {/* <Route path='/trk/success/:id' element={<Successpage />} />
        <Route path='/ms' element={<Newimgmeesho />} />
        <Route path='/meesho' element={<Meeshoprice />} /> */}




      </Routes>

    </Router>
  );
}

export default App;
